<template>
    <div
        class="ivu-vueBotton-div"
        v-show="isShow"
        :style="buttonStyle"
        @mousedown="onMouseDown"
        @mouseup="onMouseUp"
        @mouseover="onMouseOver"
        @mouseout="onMouseOut"
        @mousemove="onMouseMove"
        @dblclick="onDblclick">
        <button type="button" ref="button" class="ivu-vueBotton ivu-btn ivu-btn-default" :style="btnStyle">
          <span>{{showInnerText}}</span>
        </button>
        <div v-if="isEnable" :style="enableStyle"></div>
    </div>
</template>
<script>
export default {
    name : "fvButton",
    props : ["primitives","fvSystemApi","parentObject"],
    created(){
        //窗口边框宽度。计算图元和组件位置时需要
        this.defaultTailoring = this.parentObject.defaultTailoring;
        //窗口大小
        this.windowSize = this.parentObject.windowSize;
        //创建组件
        this.create();
        //父组件（可能是窗口也可能是组）vuex数据模型路径数组
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        //创建本省的vuex数据模型
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
        // this._getPointValue();
    },
    data(){
        var data = JSON.parse(JSON.stringify(this.primitives));
        return {
            innerText : "Button",
            showInnerText : "Button",
            buttonStyle : "",
            isShow : false,
            isEnable : false,
            originalSize : {
                x : this.x,
                y : this.y,
                width : this.width,
                height : this.height
            },
            x:'', //left
            y:'',  //top
            mouseState:0,
            scaleObj:null,
            btnStyle:{},
            color:"",
            height:'',
            width:'',
            initStyle:{
                color:data.color,
                borderColor:data.borderColor,
            },
            Text : "Button"
        }
    },
    watch: {
        Text(value){
            this.innerText = value;
            this.showInnerText = value;
            this.Text = value;
        },
        //left改变
        x(newX,oldX){
            if(this.scaleObj){
                this.$el.style.left  = parseInt((newX * (this.scaleObj.sx + this.scaleObj.zoom)) + this.scaleObj.ox) + "px";
            }
        },
        //top改变
        y(newY,oldY){
            if(this.scaleObj){
                this.$el.style.top  = parseInt(((newY + this.scaleObj.titleHeight) * (this.scaleObj.sy + this.scaleObj.zoom)) + this.scaleObj.oy) + "px";
            }
        },
        //填充色改变
        color(newColor){
            //实体文字
            if(this.animation.fvTextColor){
                this.$set(this.btnStyle,"color",newColor);
            }
            //条件
            if(this.animation.fvColorTransform){
                this.$set(this.btnStyle,"background",newColor);
            }
            //闪烁
            //打智能单元组内按钮无闪烁组加闪烁所以不需要判断是否由闪烁动画
            // if(this.animation.fvTwinkel){
                if(this.initStyle.color == newColor){
                    this.$set(this.btnStyle,"background",this.borderColor);
                    this.$set(this.btnStyle,"color",this.color);
                }else{
                    this.$set(this.btnStyle,"background",newColor);
                    this.$set(this.btnStyle,"color",this.borderColor);
                }
            // }
        },
        //高度改变
        height(newHeight){
            if(this.scaleObj){
                this.$set(this.buttonStyle,"height",parseInt(newHeight * (this.scaleObj.sx + this.scaleObj.zoom)) + "px");
                this.$set(this.buttonStyle,"lineHeight",parseInt(newHeight * (this.scaleObj.sx + this.scaleObj.zoom)) + "px");
            }

        },
        //宽度改变
        width(newWidth){
            if(this.scaleObj){
                this.$set(this.buttonStyle,"width",parseInt(newWidth * (this.scaleObj.sx + this.scaleObj.zoom)) + "px");
            }
        }
    },
    methods : {
        create(){
            this.mixin(this.primitives);
            this.getPointValue();
            this.showInnerText = this.fvSystemApi.getResource(this.innerText);
            if(this.showInnerText == undefined){
                this.Text = this.showInnerText = this.innerText;
            }
            //初始化位置 reDraw 中
            this.buttonStyle = {
                left : 0 + "px",
                top : 0 + "px",
                width : 0 + "px",
                height : 0 + "px",
            }
            this.btnStyle = {
                background:this.borderColor,
                color:this.color,
                lineHeight:"1px",
            }
            this.enableStyle = {
                position: "absolute",
                width: "100%",
                height: "100%",
                top: "0px",
                backgroundColor: "#ccbfbf",
                opacity: "0.5"
            }
            //前后置动画列表
            this.preAnimationList = [];
            this.postAnimationList = [];
            this.mouseAnimationList = [];
            for(var property in this.animation){
              //新版按钮不存在开关动画，恢复工程报错
              if(property === 'fvOutputSwitch'){
                return;
              }
                var ani = new this[property](this);
                switch(ani.type){
                    case "fvVerticalFill":
                    case "fvHorFill":
                    case "fvFlow":
                        this.postAnimationList.push(ani);
                    break;
                    case "fvContextMenu":
                    case "fvMessage":
                    case "fvVarInput":
                    case "fvBoolInput":
                    case "fvStringInput":
                    case "fvVerticalDrag":
                    case "fvHorDrag":
                    case "fvLmousescript":
                    case "fvRmousescript":
                    case "fvMousescript":
                    case "fvWindowOpen":
                        //是否禁止状态
                        // if(!this.isEnable){
                            this.mouseAnimationList[ani.type] = ani;
                        // }
                    break;
                    default:
                        this.preAnimationList[ani.type] = ani;
                    break
                }
            }
            this.isShow = true;
        },
        updateExpress(type){
            var sizeFunction = Function("return " + this.animation[type].expression);
            var size = this.fvSystemApi.system.$.executionScript(sizeFunction);
            return size;
        },
        replyOriginalSize(){
            for(var p in this.originalSize){
                this[p] = this.originalSize[p];
            }
        },

        setZoomMultiple(multiple){
            this.zoomMultiple = multiple;
        },

        zoom(){
            if(this.zoomMultiple && (this.isZoom == undefined || this.isZoom == false)){
                this.x = this.x * this.zoomMultiple.x;
                this.y = this.y * this.zoomMultiple.y;
                this.width = this.width * this.zoomMultiple.x;
                this.height = this.height * this.zoomMultiple.y;
                this.isZoom = true;
            }
        },
        //混入属性
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        //监听组件方法
        getPointValue(){
            Object.defineProperty(this,"FColor",{
                set : (value)=>{
                    if(value >= 0 && value < 2048){
                        var defaultColor = FColorToRGB.getColors();
                        var colorTemp = defaultColor[value];
                        this.$set(this.btnStyle,"background","RGB(" + colorTemp[0] + "," + colorTemp[1] + "," + colorTemp[2] + ")");
                        
                    }else{
                        console.warn("颜色索引不存在");
                    }
                },
                get : ()=>{
                    return this.color;
                }
            })
        },
        
        reDraw(scaleObj){
            this.scaleObj = scaleObj;
            
            let fontSize = parseInt(PtToPx(this.font.match(/\d{0,}px/g).toString().replace("px","")));
            //x轴缩放大于y轴
            if(scaleObj.sx < scaleObj.sy){
                fontSize = parseInt(fontSize * scaleObj.sx);
            }else{
                fontSize = parseInt(fontSize * scaleObj.sy);
            }
            let font = this.font.split(" ");
            if(this.font.length > 3){
                this.btnStyle.fontWeight = font[1];
                this.btnStyle.fontFamily = font[3];
                this.btnStyle.fontStyle = font[0];
            }else{
                this.btnStyle.fontWeight = font[0];
                this.btnStyle.fontFamily = font[2];
            }
            // 下划线
            if(this.underline){
              this.btnStyle.textDecoration = 'underline';
            }

            // 文字方向
            if(this.verticalDisplay){
              var innerHtml = '';
              for(var i = 0; i < this.showInnerText.length; i++){
                innerHtml += `<p style="height:${fontSize}px;line-height:${fontSize}px">${this.showInnerText[i]}</p>`
              }
              this.$refs.button.innerHTML = innerHtml;
            }
            this.btnStyle.position = 'absolute';
            this.btnStyle.textAlign = this.align;
            this.btnStyle.fontSize = fontSize + "px";

            // if(scaleObj.titleHeight != 0){
            //     var titleHeight = 0;
            // }else{
                // var titleHeight = this.y * this.frameScaleY;
            // }
            // this.buttonStyle.left = parseInt(((this.x + this.x * this.frameScaleX)* (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            // this.buttonStyle.top = parseInt(((this.y + titleHeight)* (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px";

            this.buttonStyle.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.buttonStyle.top  = parseInt(((this.y)* (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px";

            this.buttonStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.buttonStyle.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
            this.borderColor=this.FColor;
            // 字体宽度超出按钮宽度
            switch(this.align){
              case 'center':
                if(this.$refs.button.children["0"].offsetWidth > parseInt(this.buttonStyle.width)){
                  //this.$refs.button.children["0"].style.marginLeft = (parseInt(this.buttonStyle.width) - this.$refs.button.children["0"].offsetWidth) / 2 + 'px';
                }
                break;
              case 'right':
                if(this.$refs.button.children["0"].offsetWidth > parseInt(this.buttonStyle.width)){
                  //this.$refs.button.children["0"].style.marginLeft = (parseInt(this.buttonStyle.width) - this.$refs.button.children["0"].offsetWidth)+ 'px';
                }
                break;
              default:
                break;
            }
        },
        /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
        doFixedEvent(){

        },
        runMouseAnimation(event,mouseAnimType){
            if(this.isEnable || this.mouseAnimationList[mouseAnimType] == undefined){
                return;
            }
            if(event.type == "mousemove" && mouseAnimType == "fvLmousescript"){
                return;
            }
            this.mouseAnimationList[mouseAnimType].run(event);
        },
        /*
            参数：
            作用：下鼠标按钮时执行
        */
        onMouseDown(e){
            this.mouseState = 1;
            this.dispose(e);
        },
         /*
            参数：
            作用：松开鼠标按钮时执行
        */
        onMouseUp(e){
            this.mouseState = 1;
            this.dispose(e);
        },
        /*
            参数：
            作用：鼠标指针位于元素上方时执行
        */
        onMouseOver(e){
            this.mouseState = 1;
            this.dispose(e);
        },
        /*
            参数：
            作用：鼠标从元素上移开时执行
        */
        onMouseOut(e){
            this.mouseState = 0;
            this.dispose(e);
        },
         /*
            参数：
            作用：鼠标在元素上移动时执行
        */
        onMouseMove(e){
            this.mouseState = 1;
            this.dispose(e);
        },
         /*
            参数：
            作用：鼠标双击执行
        */
        onDblclick(e){
            this.mouseState = 1;
            this.dispose(e);
        },
        dispose(e){
            if(e.touches){
                this.runMouseAnimation(e,"fvLmousescript");
                this.runMouseAnimation(e,"fvVarInput");
                this.runMouseAnimation(e,"fvBoolInput");
                this.runMouseAnimation(e,"fvStringInput");
                this.runMouseAnimation(e,"fvVerticalDrag");
                this.runMouseAnimation(e,"fvHorDrag");
                this.runMouseAnimation(e,"fvWindowOpen");
            }else{
                switch(e.button)
                {
                    case 0://鼠标左键
                        this.runMouseAnimation(e,"fvMessage");
                        this.runMouseAnimation(e,"fvLmousescript");
                        this.runMouseAnimation(e,"fvMousescript");
                        this.runMouseAnimation(e,"fvVarInput");
                        this.runMouseAnimation(e,"fvBoolInput");
                        this.runMouseAnimation(e,"fvStringInput");
                        this.runMouseAnimation(e,"fvVerticalDrag");
                        this.runMouseAnimation(e,"fvHorDrag");
                        this.runMouseAnimation(e,"fvWindowOpen");
                        break;
                    case 1://滚轮
                        this.runMouseAnimation(e,"fvRmousescript");
                        break;
                    case 2://2：右键
                        this.runMouseAnimation(e,"fvRmousescript");
                        this.runMouseAnimation(e,"fvContextMenu");
                        break;
                    default:
                        break;
                }
            }
        },
        onTimer(time,flag){
            //是否禁止状态
            var old = this.showInnerText;
            this.showInnerText = this.fvSystemApi.getResource(this.innerText);
            if(this.showInnerText == undefined){
                if(old == undefined){
                    this.showInnerText = this.innerText;
                }else{
                    this.showInnerText = old;
                }
                
            }
            // this.borderColor=this.FColor;
            // if(!this.preAnimationList && this.preAnimationList.length > 0){
              for(var p in this.preAnimationList){
                  if(this.preAnimationList) return
                  this.preAnimationList[p].run(this.parentObject.cacheCtx);
              }
            // }
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show(isShow){
            this.isShow = isShow ? true:false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable(isEnable){
            this.isEnable = isEnable ? false : true;
        },
    },
}
</script>
<style>

    .ivu-vueBotton-div {
        position: absolute;
        padding : 0;

    }
    .ivu-vueBotton-div .ivu-btn{
        padding:0;
    }
    .ivu-vueBotton {
        width : 100%;
        height : 100%;
        border: 1px solid rgba(0,0,0,.2);
        border-radius: .3em;
        box-shadow: 0 1px white inset;
        text-align: center;
    }
    .ivu-vueBotton:active{
       box-shadow: .05em .1em .2em rgba(0,0,0,.5) inset;
       border-color: rgba(0,0,0,.3);
    }
</style>



// WEBPACK FOOTER //
// src/components/primitives/fvButton/fvButton.vue